
 
export class storePatientIdAction {
    static readonly type = '[patientId] PatientId';

    constructor(public payload:{patientId:number,pageType:any}) {
    }
}
// export class storePageTypeAction {
//     static readonly type = '[pageType] pageType';

//     constructor(public payload: any) {
//     }
// }